import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {} from '@catalogit/common/lib/types/media.js';
const useStyles = makeStyles(() => createStyles({
    medium: {
        position: 'relative',
        width: '100%',
        height: 0
    },
    mediumImg: {
        display: 'block',
        position: 'absolute',
        width: '100%', // TODO ??? should this be maxWidth
        maxWidth: '100%',
        maxHeight: '100%',
        lineHeight: 1
    }
}));
const SizedImage = ({ medium, alt, onClick, style }) => {
    const classes = useStyles();
    return (_jsx("div", { className: classes.medium, style: {
            paddingBottom: `${(medium.height / medium.width) * 100}%`,
            ...style
        }, onClick: onClick, children: _jsx("img", { className: classes.mediumImg, src: medium.path, alt: alt }) }));
};
export default SizedImage;
//# sourceMappingURL=SizedImage.js.map